import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import { useTheme } from 'foundations-theming/utils';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import HorizontalLayoutContainer from '../features/publicLayout/components/HorizontalLayoutContainer';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PageSkeleton = () => {
  const theme = useTheme();
  const {
    isMobile
  } = useMediaQuery();
  const skeletonProps = {
    animated: true,
    backgroundcolor: theme.color['fill-surface-recessed'],
    shimmercolor: theme.color['fill-surface-default']
  };
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "page-skeleton",
    children: [/*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-default",
      paddingBlock: "400",
      children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
        children: /*#__PURE__*/_jsx(ACSkeletonBox, Object.assign({}, skeletonProps, {
          style: {
            width: '160px',
            height: '60px',
            borderRadius: '4px'
          }
        }))
      })
    }), /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-recessed",
      paddingBlock: "800",
      children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
        children: [/*#__PURE__*/_jsx(ACSkeletonBox, Object.assign({}, skeletonProps, {
          style: {
            width: '280px',
            height: '16px',
            marginBottom: '16px',
            borderRadius: '4px'
          }
        })), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '800' : '1100',
          children: [/*#__PURE__*/_jsxs(Box, {
            flex: "1",
            minInlineSize: isMobile ? '100%' : '55%',
            children: [/*#__PURE__*/_jsx(ACSkeletonBox, Object.assign({}, skeletonProps, {
              style: {
                width: '180px',
                height: '24px',
                marginBottom: '12px',
                borderRadius: '4px'
              }
            })), /*#__PURE__*/_jsx(ACSkeletonBox, Object.assign({}, skeletonProps, {
              style: {
                width: '100%',
                maxWidth: '520px',
                height: '48px',
                marginBottom: '16px',
                borderRadius: '4px'
              }
            })), /*#__PURE__*/_jsx(ACSkeletonBox, Object.assign({}, skeletonProps, {
              style: {
                width: '140px',
                height: '28px',
                marginBottom: '20px',
                borderRadius: '16px'
              }
            })), /*#__PURE__*/_jsx(ACSkeletonBox, Object.assign({}, skeletonProps, {
              style: {
                width: '100%',
                maxWidth: '480px',
                height: '72px',
                marginBottom: '24px',
                borderRadius: '4px'
              }
            }))]
          }), !isMobile && /*#__PURE__*/_jsx(Box, {
            flex: "0 0 320px",
            children: /*#__PURE__*/_jsx(ACSkeletonBox, Object.assign({}, skeletonProps, {
              style: {
                width: '100%',
                height: '280px',
                borderRadius: '8px'
              }
            }))
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(View, {
      paddingBlock: "600",
      children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
        children: [/*#__PURE__*/_jsx(ACSkeletonBox, Object.assign({}, skeletonProps, {
          style: {
            width: '200px',
            height: '24px',
            marginBottom: '16px',
            borderRadius: '4px'
          }
        })), /*#__PURE__*/_jsxs(Flex, {
          flexWrap: "wrap",
          gap: "400",
          children: [/*#__PURE__*/_jsx(ACSkeletonBox, Object.assign({}, skeletonProps, {
            style: {
              width: '100%',
              maxWidth: '400px',
              height: '16px',
              borderRadius: '4px'
            }
          })), /*#__PURE__*/_jsx(ACSkeletonBox, Object.assign({}, skeletonProps, {
            style: {
              width: '100%',
              maxWidth: '360px',
              height: '16px',
              borderRadius: '4px'
            }
          })), /*#__PURE__*/_jsx(ACSkeletonBox, Object.assign({}, skeletonProps, {
            style: {
              width: '100%',
              maxWidth: '320px',
              height: '16px',
              borderRadius: '4px'
            }
          }))]
        })]
      })
    })]
  });
};
export default PageSkeleton;